var map = {
	"./base.js": "5Og+",
	"./common.js": "Cvgy",
	"./index.js": "+vOg"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "te/c";


//////////////////
// WEBPACK FOOTER
// ./src/services nonrecursive \.js$
// module id = te/c
// module chunks = 225